module.exports = __webpack_public_path__ + "img/crew2.85277bc5.jpg";